import { getAppConfig } from '@client/core/config/get-app-config';
import { AuthUser } from '@client/features/auth/models/auth-user';

/**
 * Get an object representing the currently Authenticated User.
 * NOTE: The returned AuthUser object is similar to a normal User but has a
 * few additional fields.
 */
export function getCurrentUser(): AuthUser {
  const { currentUser } = getAppConfig();

  return currentUser;
}
